import { TRAINER_LIST, TRAINER_DETAILS } from './../constant/ActionTypes';

export const trainerReducer = (state, action) => {
    switch (action.type) {
        case TRAINER_LIST:
            return { ...state, trainerList: action.payload };
        case TRAINER_DETAILS:
            return { ...state, trainerDetails: action.payload };
        default: {
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./contexts/reducer/trainerReducer.js